import React from 'react'
import { router, usePage } from '@inertiajs/react'
import {
  Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Paper, Typography, Chip,
} from '@mui/material'
import AddIcon from '@mui/icons-material/Add'
import AppShell from '../../../../components/layout/AppShell'
import PageHeader from '../../../../components/ui/PageHeader'
import StatusBadge from '../../../../components/ui/StatusBadge'

Index.layout = (page) => <AppShell>{page}</AppShell>

export default function Index({ property, distribution_keys }) {
  const { props } = usePage()
  const tenant = props.tenant || {}
  const basePath = `/m/${tenant.slug}/properties/${property.id}/distribution_keys`

  return (
    <Box>
      <PageHeader
        title="Verteilerschlüssel"
        breadcrumbs={[
          { label: 'Verteilerschlüssel' },
        ]}
        actions={
          <Button variant="contained" startIcon={<AddIcon />}
            onClick={() => router.visit(`${basePath}/new`)}
            data-testid="new-key-btn">
            Neuer Schlüssel
          </Button>
        }
      />

      <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider' }}>
        <Table size="small">
          <TableHead>
            <TableRow sx={{ backgroundColor: 'background.subtle' }}>
              <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Typ</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Attribut</TableCell>
              <TableCell sx={{ fontWeight: 600 }}>Zugeordnete Kostenarten</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {distribution_keys.length === 0 && (
              <TableRow>
                <TableCell colSpan={4} align="center" sx={{ py: 4 }}>
                  <Typography color="text.secondary">Keine Verteilerschlüssel vorhanden.</Typography>
                </TableCell>
              </TableRow>
            )}
            {distribution_keys.map((dk) => (
              <TableRow key={dk.id} hover sx={{ cursor: 'pointer' }}
                onClick={() => router.visit(`${basePath}/${dk.id}`)}
                data-testid={`key-row-${dk.id}`}>
                <TableCell><Typography variant="body2" fontWeight={500}>{dk.name}</Typography></TableCell>
                <TableCell><StatusBadge type="distribution_key_type" value={dk.key_type} /></TableCell>
                <TableCell>{dk.attribute_name || '–'}</TableCell>
                <TableCell>
                  {dk.cost_categories.length > 0
                    ? dk.cost_categories.map((name, i) => (
                        <Chip key={i} label={name} size="small" variant="outlined" sx={{ mr: 0.5, mb: 0.5 }} />
                      ))
                    : '–'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
